//
// locale_id.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/id.json';
import localeData from "react-intl/locale-data/id.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_id.js